import IconAsButton from "src/components/IconAsButton";
import withRouter from "src/routing/withRouter";
import { ReactComponent as BackIcon } from "./back.svg";

function BackButton({
  absolute = false,
  size = "20px",
  onClick,
  fill,
  router,
  goTo,
  ...rest
}) {
  const { navigate, location } = router;
  let onClickHandler = () => navigate(-1);
  if (typeof goTo === "string") {
    onClickHandler = () => navigate(goTo);
  }
  if (typeof onClick === "function") {
    onClickHandler = () => onClick({ navigate, location });
  }
  return (
    <IconAsButton
      fill={fill}
      onClick={onClickHandler}
      icon={BackIcon}
      size={size}
      position={absolute ? "absolute" : "static"}
      top={absolute ? "14px" : "0"}
      left={absolute ? "20px" : "0"}
      zIndex={absolute ? 100 : "auto"}
      {...rest}
    />
  );
}

export default withRouter(BackButton);
